goog.provide("shadow.js.shim.module$$mui$icons_material$Refresh");
goog.provide("module$shadow_js_shim_module$$mui$icons_material$Refresh");
shadow.js.shim.module$$mui$icons_material$Refresh = shadow.js.nativeProvides["@mui/icons-material/Refresh"] = shadow$bridge("@mui/icons-material/Refresh");
module$shadow_js_shim_module$$mui$icons_material$Refresh.default = shadow.js.shim.module$$mui$icons_material$Refresh;
